import { Box, Stack, Typography } from "@mui/material";
import { CopyToClipboard } from "components/ui/atoms/CopyToClipboard";
import dayjs from "dayjs";
import NotificationIcon from "models/notes/NotificationIcon";

const NoteHeader = ({ note, onClose }) => {
  return (
    <>
      <CopyToClipboard
        text={new URL(`/note/${note.id}`, document.baseURI).href}
        edge={!onClose && "start"}
      />
      <Stack spacing={0} sx={{ ml: 1, flexGrow: 1 }}>
        <Box>
          <Typography variant="h1" component="span">
            {note.subject}
          </Typography>
        </Box>
        <Typography variant="caption">
          Created by {note.owner_detail.fullname} - at{" "}
          {dayjs(note.created_at).format("DD/MM/YYYY")}
        </Typography>
      </Stack>
      <NotificationIcon {...note} />
    </>
  );
};

export default NoteHeader;
